<div class="modal-header" id="cse-sales-tid-modal-title">
    <h3 class="modal-title" id="modal-title" translate="DASHBOARD_SIDEMENU_SALES_QUOTE_TITLE"></h3>
    <span class="close" (click)="!isLoading && modalInstance.hide()">&times;</span>
</div>
<div class="modal-body" id="modal-body">
    <form [formGroup]="cseSalesTidInputForm">
        <fieldset formArrayName="formChildren" [disabled]="isLoading">
            <!-- Text input-->
            <div class="row mb-sm-3">
                <label
                    class="col-sm-4 col-form-label text-sm-end text-start"
                    translate="DASHBOARD_SIDEMENU_SALES_QUOTE_TECH_IDENT_NUMBER"
                ></label>
                <div class="col-sm-6">
                    <pace-core-text-input
                        [(model)]="model.techIdentNumber"
                        (valueChange)="validateForm()"
                        [parentForm]="formChildren"
                        [ariaLabel]="'DASHBOARD_SIDEMENU_SALES_QUOTE_TECH_IDENT_NUMBER' | translate"
                    ></pace-core-text-input>
                </div>
            </div>
            <div class="row mb-sm-3">
                <label
                    class="col-sm-4 col-form-label text-sm-end text-start"
                    translate="DASHBOARD_SIDEMENU_SALES_QUOTE_FUNCTIONAL_LOCATION"
                ></label>
                <div class="col-sm-6">
                    <pace-core-text-input
                        [(model)]="model.functionalLoc"
                        (valueChange)="validateForm()"
                        [parentForm]="formChildren"
                        [ariaLabel]="'DASHBOARD_SIDEMENU_SALES_QUOTE_FUNCTIONAL_LOCATION' | translate"
                    ></pace-core-text-input>
                </div>
            </div>
            <div class="row mb-sm-3">
                <label
                    class="col-sm-4 col-form-label text-sm-end text-start"
                    translate="DASHBOARD_SIDEMENU_SALES_QUOTE_MATERIAL"
                ></label>
                <div class="col-sm-6">
                    <pace-core-text-input
                        [(model)]="model.material"
                        (valueChange)="validateForm()"
                        [parentForm]="formChildren"
                        [ariaLabel]="'DASHBOARD_SIDEMENU_SALES_QUOTE_MATERIAL' | translate"
                    ></pace-core-text-input>
                </div>
            </div>
            <div class="row mb-sm-3">
                <label
                    class="col-sm-4 col-form-label text-sm-end text-start"
                    translate="DASHBOARD_SIDEMENU_SALES_QUOTE_SERIAL_NUMBER"
                ></label>
                <div class="col-sm-6">
                    <pace-core-text-input
                        [(model)]="model.serialNo"
                        (valueChange)="validateForm()"
                        [parentForm]="formChildren"
                        [ariaLabel]="'DASHBOARD_SIDEMENU_SALES_QUOTE_SERIAL_NUMBER' | translate"
                    ></pace-core-text-input>
                </div>
            </div>
        </fieldset>
    </form>
</div>
<div class="modal-footer">
    <button
        *ngIf="!isLoading"
        class="btn btn-primary"
        type="button"
        (click)="submit()"
        [disabled]="cseSalesTidInputForm.invalid"
        translate="DASHBOARD_SIDEMENU_SALES_QUOTE_GET"
    ></button>
    <progressbar *ngIf="isLoading" [value]="100" type="default">Loading... </progressbar>
</div>
